import { Badge } from '@/components/ui/badge';
import { LOGO_J_PATH_32 } from '@/lib/logoMark';


interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showBadge?: boolean;
  badgeText?: string;
  onClick?: () => void;
  /** Só a marca (sem o nome escrito) — menu recolhido, onde não cabe o texto. */
  iconOnly?: boolean;
}

const sizes = {
  small: { icon: 32, fontSize: 'text-lg' },
  medium: { icon: 40, fontSize: 'text-[22px]' },
  large: { icon: 56, fontSize: 'text-[32px]' },
};

export function Logo({ size = 'medium', showBadge = false, badgeText = 'Premium', onClick, iconOnly = false }: LogoProps) {
  const s = sizes[size];

  return (
    <div
      className={`flex items-center gap-3 ${onClick ? 'cursor-pointer' : 'cursor-default'}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label={onClick ? 'Ir para página inicial' : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      <svg
        viewBox="0 0 32 32"
        style={{ width: s.icon, height: s.icon }}
        className="drop-shadow-[0_2px_8px_rgba(122,36,48,0.4)]"
        aria-hidden="true"
      >
        <rect width="32" height="32" rx="5.33" fill="var(--color-primary)" />
        <path d={LOGO_J_PATH_32} fill="#ffffff" />
      </svg>
      {!iconOnly && (
        <div>
          <span className={`${s.fontSize} font-bold tracking-tight leading-none text-[var(--color-text-primary)]`}>
            <span className="text-primary">JURIS</span>
            APP
          </span>
          {showBadge && (
            <div className="mt-1">
              <Badge
                variant="secondary"
                className="h-[18px] text-[11px] font-bold bg-primary/10 text-primary border-transparent"
              >
                {badgeText}
              </Badge>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Logo;
